module.exports = __webpack_public_path__ + "img/no_img.8b223290.jpg";